import React from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

export const IntlWrapper: React.FC<any> = ({ children }) => {
    const i18n = useSelector((state: { I18n: any }) => state.I18n);
    return <IntlProvider {...i18n}>{children}</IntlProvider>;
};
